<script>
import { pageTitleMixin } from '@ubic/vue-mixins';
import { permissions } from '@/constants';
import ErrorAccessDenied from '@/components/ErrorAccessDenied';

const availableFormats = ['xlsx', 'csv'];
const availableFields = {
  date: 'дата',
  worker: 'сотрудник',
  project: 'проект',
  hours: 'трудозатраты',
  task: 'описание задачи',
  taskNumber: 'номер задачи',
};

export default {
  pageTitle: 'Экспорт лога действий',
  mixins: [pageTitleMixin],
  data () {
    return {
      name: 'payload_log',
      respectFilter: true,
      format: availableFormats[0],
      fields: Object.keys(availableFields),
    };
  },
  computed: {
    hasReadPermission () {
      return this.$store
        .getters['auth/checkPermission'](permissions.LOG_READ);
    },
    hasTaskReadPermission () {
      return this.$store
        .getters['auth/checkPermission'](permissions.LOG_READ_TASK);
    },
    exportRoute () {
      const path = '/api/log/export';
      const query = {
        ...(this.respectFilter ? this.$route.query : {}),
        format: this.format,
        name: this.name,
        fields: this.fields.join(','),
      };

      return this.$router.resolve({ path, query });
    },
  },
  methods: {
    handleNameInput (value) {
      this.name = value;
    },
    handleFieldsChange (value) {
      this.fields = value;
    },
    handleRespectFilterChange (checked) {
      this.respectFilter = checked;
    },
    handleFormatChange (value) {
      this.format = value;
    },

    handleDownload (e) {
      e.preventDefault();

      if (!this.fields.length) {
        return;
      }

      const { href } = this.exportRoute;

      const link = document.createElement('a');
      link.href = href;
      link.download = `${this.name}.${this.format}`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    handleClose () {
      this.$emit('close');
      this.$router.replace({
        ...this.$route,
        path: '/logs',
      });
    },
  },
  render () {
    if (!this.hasReadPermission) {
      return (
        <u-modal onClose={this.handleClose}>
          <ErrorAccessDenied />
        </u-modal>
      );
    }

    const { $style, hasTaskReadPermission } = this;

    return (
      <u-modal onClose={this.handleClose}>
        <u-title
          slot="header"
          level="2"
        >
          Экспорт лога
        </u-title>

        <form
          action="#"
          method="post"
          onSubmit={this.handleDownload}
        >
          <div class="form-field">
            <div class="form-field__label">
              <label for="nameInput">
                Название файла
              </label>
            </div>
            <u-input
              id="nameInput"
              placeholder="payload_log"
              value={this.name}
              onInput={this.handleNameInput}
            />
          </div>

          <div class="form-field">
            <div class="form-field__label">
              Включить поля
            </div>
            <div class={$style.options}>
              {Object
                .keys(availableFields)
                .filter(key => (key === 'task' ? hasTaskReadPermission : true))
                .map(field => (
                  <div
                    key={field}
                    class={$style.optionsItem}
                  >
                    <u-checkbox
                      value={field}
                      checked={this.fields}
                      onChange={this.handleFieldsChange}
                    >
                      {availableFields[field]}
                    </u-checkbox>
                  </div>
                ))}
            </div>
          </div>

          <div class="form-field">
            <div class="form-field__label">
              Формат
            </div>
            <div class={$style.inlineOptions}>
              {availableFormats.map(format => (
                <span
                  key={format}
                  class={$style.inlineOptionsItem}
                >
                  <u-radio
                    checked={this.format}
                    value={format}
                    onChange={this.handleFormatChange}
                  >
                    {format}
                  </u-radio>
                </span>
              ))}
            </div>
          </div>

          <footer class="form-footer">
            <u-btn
              size="wide"
              type="submit"
              disabled={!this.fields.length}
            >
              Скачать
            </u-btn>

            <u-checkbox
              class={$style.respectFilterCheckbox}
              checked={this.respectFilter}
              onChange={this.handleRespectFilterChange}
            >
              учитывать фильтр
            </u-checkbox>
          </footer>
        </form>
      </u-modal>
    );
  },
};
</script>

<style lang="scss" module>
@import '@/theme/include.scss';

.options {
  &Item {
    & + & {
      margin-top: .25em;
    }
  }
}

.inlineOptions {
  display: flex;

  &Item {
    margin-right: 2em;
  }
}

.respectFilterCheckbox {
  font-size: .825em;
  margin-left: 2em;
}
</style>
